import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    question: "I have not started writing yet. Is this too early?",
    answer:
      "That is the ideal moment. Stage one exists for aspiring authors: we shape the concept, define the reader, and build a chapter outline so the writing has direction from day one.",
  },
  {
    question: "I already have a rough manuscript. What happens next?",
    answer:
      "Upload it for a Manuscript Review. You receive paragraph-level editorial feedback tied to specific publishing principles — what is strong, what is vague, and exactly what to rework, chapter by chapter.",
  },
  {
    question: "Is my intellectual property safe?",
    answer:
      "Yes. Your manuscript is encrypted, visible only to you and the reviewer assigned to your account. You own one hundred percent of your content and can export or delete it at any time.",
  },
  {
    question: "Do I need to be technical?",
    answer:
      "No coding and no plugins. If you can upload a document and click Next, you are set. Our team handles the build, and onboarding walks you through the rest.",
  },
  {
    question: "How long does it take to launch Extend?",
    answer:
      "Most authors go live within two to four weeks of handing over their content, including AI tuning and review. If your material is ready, it can be faster.",
  },
  {
    question: "What file types can I upload for review?",
    answer:
      "PDF and Microsoft Word (.docx) up to 15MB. Manuscripts of roughly 250 pages are supported, and longer books can be split into parts.",
  },
  {
    question: "Does this replace my publisher?",
    answer:
      "Not at all. AuthorPro is author-first and coexists with traditional publishing deals. Many publishers partner with us to extend the life of their backlist.",
  },
  {
    question: "What stops the AI from inventing things?",
    answer:
      "Responses are generated from your text using retrieval-augmented generation, citing your exact paragraphs. Anything outside your material is flagged before a reader sees it.",
  },
];

const FaqNoir = () => (
  <section id="faq" aria-labelledby="faq-heading" className="py-20 md:py-28 border-t border-border">
    <div className="container mx-auto px-4">
      <div className="grid gap-12 lg:grid-cols-[0.85fr_1.4fr] lg:gap-20">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <div className="flex items-center gap-3 mb-5">
            <span className="rule-gold" aria-hidden />
            <p className="eyebrow">Questions</p>
          </div>
          <h2 id="faq-heading" className="text-3xl sm:text-4xl md:text-[2.75rem] font-semibold leading-[1.1] mb-5">
            Everything authors ask before they begin.
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Still unsure which stage you are in? Book a discovery call and we will tell you honestly
            — including when the answer is "not yet".
          </p>
        </div>

        <Accordion type="single" collapsible className="divide-y divide-border border-y border-border">
          {FAQS.map(({ question, answer }, idx) => (
            <AccordionItem key={idx} value={`faq-${idx}`} className="border-0">
              <AccordionTrigger className="py-6 text-left font-serif text-lg md:text-xl hover:no-underline hover:text-gold [&>svg]:text-gold">
                <span className="flex gap-5">
                  <span className="font-serif italic text-sm text-gold/70 pt-1.5 tabular-nums">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  {question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-7 pl-[2.6rem] pr-2 text-[15px] leading-[1.75] text-muted-foreground">
                {answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FaqNoir;
